/* eslint-disable */
import React, { useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { reactSelectStyle } from "Config/Config";
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";
import { fetchOptions } from "helper/Common/CommonHelper";
import { getMemberOptions } from "helper/ContactHelper/ContactHelper";

const SaveResultPopup = ({
  selectedResultId,
  setSelectedResultId,
  afterActionClose,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [severities, setSeverities] = useState([]);
  const [facilityOptions, setFacilityOptions] = useState([]);

  // Define states for all input fields
  const [testName, setTestName] = useState("");
  const [testCategory, setTestCategory] = useState("");
  const [orderDate, setOrderDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [testDate, setTestDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [resultDate, setResultDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [result, setResult] = useState("");
  const [unit, setUnit] = useState("");
  const [referenceRange, setReferenceRange] = useState("");
  const [severity, setSeverity] = useState(null);
  const [referredBy, setReferredBy] = useState("");
  const [provider, setProvider] = useState("");
  const [facility, setFacility] = useState(null);
  const [comments, setComments] = useState("");
  const [assignTo, setAssignTo] = useState(null);

  const [isSaving, setIsSaving] = useState(false);

  // Async load options for assignee
  const loadAssineeOptions = async (inputValue) => {
    try {
      const options = await getMemberOptions(inputValue);
      return options;
    } catch (error) {
      return [];
    }
  };

  //function for get result details
  const getResultDetails = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_MEDICAL_TEST_BY_ID +
        `/${selectedResultId}`;

      console.log("requestUrl", requestUrl);

      const response = await getData(requestUrl);

      console.log("response", response);

      if (response.status) {
        const resultData = response.data;

        setTestName(resultData.testname);
        setTestCategory(resultData.testcategory);
        setOrderDate(
          resultData.orderdate
            ? new Date(resultData.orderdate).toISOString().split("T")[0]
            : ""
        );
        setTestDate(
          resultData.testdate
            ? new Date(resultData.testdate).toISOString().split("T")[0]
            : ""
        );
        setResultDate(
          resultData.resultdate
            ? new Date(resultData.resultdate).toISOString().split("T")[0]
            : ""
        );
        setResult(resultData.result);
        setUnit(resultData.unit);
        setReferenceRange(resultData.referencerange);
        setSeverity({
          value: resultData.severity,
          label: resultData.severity,
        });
        setReferredBy(resultData.referredby);
        setProvider(resultData.provider);
        setFacility({
          value: resultData.facility,
          label: resultData.facility,
        });
        setComments(resultData.comments);
        if (resultData.assignedtovalue) {
          setAssignTo({
            value: resultData.assignedtovalue,
            label: resultData.assignedtolabel,
          });
        }
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  //function for save result
  const saveResultHandler = async () => {
    try {
      setIsSaving(true);
      const apiData = {
        testname: testName,
        testcategory: testCategory,
        orderdate: orderDate,
        testdate: testDate,
        resultdate: resultDate,
        result: result,
        unit: unit,
        referencerange: referenceRange,
        severity: severity?.value,
        referredby: referredBy,
        provider: provider,
        facility: facility?.value,
        comments: comments,
        assignto: assignTo ? assignTo?.value : null,
      };

      console.log("apiData", apiData);

      let requestUrl = url.API_BASE_URL;

      let response = {};

      if (selectedResultId) {
        requestUrl +=
          url.API_UPDATE_MEDICAL_TEST + `/${selectedResultId}`;
        response = await putData(requestUrl, apiData);
      } else {
        requestUrl += url.API_ADD_MEDICAL_TEST;

        response = await postData(requestUrl, apiData);
      }

      setIsSaving(false);

      console.log(response);

      if (response.status) {
        //close offcanvas
        bootstrap.Offcanvas.getInstance(
          document.querySelector("#saveResultOffCanvas")
        ).hide();
        resetHandler();
        afterActionClose([response.data]);
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  const resetHandler = () => {
    setTestName("");
    setTestCategory("");
    setOrderDate(new Date().toISOString().split("T")[0]);
    setTestDate(new Date().toISOString().split("T")[0]);
    setResultDate(new Date().toISOString().split("T")[0]);
    setResult("");
    setUnit("");
    setReferenceRange("");
    setSeverity(null);
    setReferredBy("");
    setProvider("");
    setFacility(null);
    setComments("");
    setAssignTo(null);
    setSelectedResultId(null);
  };

  useEffect(() => {
    if (selectedResultId) {
      getResultDetails();
    }
  }, [selectedResultId]);

  useEffect(() => {
    fetchOptions(
      `${url.SERVER_URL}${url.ALLERGY_SEVERITIES_OPTIONS}`,
      setSeverities
    );
    fetchOptions(
      `${url.SERVER_URL}${url.HOSPITALS_OPTIONS}`,
      setFacilityOptions
    );
  }, []);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="saveResultOffCanvas"
      aria-labelledby="saveResultOffCanvas"
    >
      {/* Header */}
      <div className="offcanvas-header bg-primary text-white p-4 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              science
            </span>
          </div>
          <div>
            <h3 className="offcanvas-title fw-bold text-white mb-0">
              Save Result
            </h3>
            <p className="text-white fs-sm mb-0">
              Add or update test result details
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-2 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <div className="p-3 p-md-4 border border-gray-300 rounded-10 shadow-sm">
          <form onSubmit={(e) => e.preventDefault()}>
            {/* 1. Test Name */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Test Name</label>
              <input
                type="text"
                name="testName"
                value={testName}
                onChange={(e) => setTestName(e.target.value)}
                className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                placeholder="Enter Test Name"
              />
            </div>
            {/* 2. Test Category */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Test Category</label>
              <input
                type="text"
                name="testCategory"
                value={testCategory}
                onChange={(e) => setTestCategory(e.target.value)}
                className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                placeholder="Enter Test Category"
              />
            </div>
            {/* 3. Order Date, 4. Test Date, 5. Result Date in one row */}
            <div className="row">
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">Order Date</label>
                <input
                  type="date"
                  name="orderDate"
                  value={orderDate}
                  onChange={(e) => setOrderDate(e.target.value)}
                  className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                />
              </div>
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">Test Date</label>
                <input
                  type="date"
                  name="testDate"
                  value={testDate}
                  onChange={(e) => setTestDate(e.target.value)}
                  className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                />
              </div>
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">Result Date</label>
                <input
                  type="date"
                  name="resultDate"
                  value={resultDate}
                  onChange={(e) => setResultDate(e.target.value)}
                  className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                />
              </div>
            </div>
            {/* 6. Result */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Result</label>
              <input
                type="text"
                name="result"
                value={result}
                onChange={(e) => setResult(e.target.value)}
                className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                placeholder="Enter Result"
              />
            </div>
            {/* 7. Unit and 8. Reference Range in one row */}
            <div className="row">
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">Unit</label>
                <input
                  type="number"
                  name="unit"
                  value={unit}
                  onChange={(e) => setUnit(e.target.value)}
                  className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                  placeholder="Enter Unit"
                />
              </div>
              <div className="form-group mb-4 col">
                <label className="d-block fw-semibold mb-2">
                  Reference Range
                </label>
                <input
                  type="number"
                  name="referenceRange"
                  value={referenceRange}
                  onChange={(e) => setReferenceRange(e.target.value)}
                  className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                  placeholder="Enter Reference Range"
                />
              </div>
            </div>
            {/* 9. Severity */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Severity</label>
              <Select
                isClearable
                name="severity"
                options={severities}
                placeholder="Select Severity"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={severity}
                onChange={setSeverity}
              />
            </div>
            {/* 10. Referred By */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Referred By</label>
              <input
                type="text"
                name="referredBy"
                value={referredBy}
                onChange={(e) => setReferredBy(e.target.value)}
                className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                placeholder="Enter Referred By"
              />
            </div>
            {/* 11. Provider */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Provider</label>
              <input
                type="text"
                name="provider"
                value={provider}
                onChange={(e) => setProvider(e.target.value)}
                className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                placeholder="Enter Provider"
              />
            </div>
            {/* 12. Facility */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Facility</label>
              <Select
                isClearable
                name="facility"
                options={facilityOptions}
                placeholder="Select Facility"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={facility}
                onChange={setFacility}
              />
            </div>
            {/* 13. Comments */}
            <div className="form-group mb-4">
              <label htmlFor="comments" className="d-block fw-semibold mb-2">
                Comments
              </label>
              <textarea
                name="comments"
                id="comments"
                rows="5"
                placeholder="Enter Comments"
                className="form-control px-4 py-3 lh-1 rounded-10 border-gray-100 shadow-none"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              ></textarea>
            </div>
            {/* 14. Assign To */}
            <div className="form-group mb-4">
              <label className="d-block fw-semibold mb-2">Assign To</label>
              <AsyncSelect
                isClearable
                name="assignTo"
                loadOptions={loadAssineeOptions}
                defaultOptions={false}
                cacheOptions={false}
                placeholder="Select Assignee"
                styles={reactSelectStyle("3px", "6px", true, false)}
                value={assignTo}
                onChange={setAssignTo}
              />
            </div>
            <div className="group_btnOuter d-flex justify-content-end pt-3 border-top mt-auto">
              <button
                type="button"
                className="btn btn-primary d-flex align-items-center gap-2"
                onClick={saveResultHandler}
                disabled={isSaving}
                style={{
                  cursor: isSaving ? "not-allowed" : "pointer",
                }}
              >
                {isSaving ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Saving...
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">save</span>
                    Save Result
                  </>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SaveResultPopup;
